import Styles from "../impact-success-story/SuccessStory.module.scss";
import bm from "../100-board-members/BoardMembers100.module.scss";
import { useEffect, useState } from "react";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import ButtonWithLinks from "../buttons/ButtonWithLink";
import { useNavigate, useLocation } from "react-router-dom";
import { Dialog, DialogActions, DialogTitle } from "@mui/material";

import AOS from "aos";
import {
  fetchStoriesData,
  getCounts,
  getCatgoryData,
} from "../../service/imapctService";
import { ThreeCircles } from "react-loader-spinner";
import { urls } from "../../utils/urls";

const filterFieldSx = {
  minWidth: { xs: "100%", sm: 200, md: 220 },
  "& .MuiOutlinedInput-root": {
    color: "rgba(255,255,255,0.95)",
    "& fieldset": { borderColor: "rgba(255,255,255,0.25)" },
    "&:hover fieldset": { borderColor: "rgba(255,255,255,0.45)" },
    "&.Mui-focused fieldset": { borderColor: "#f52929" },
  },
  "& .MuiInputLabel-root": {
    color: "rgba(255,255,255,0.65)",
    "&.Mui-focused": { color: "#f52929" },
  },
};

export default function SuccessStory() {
  const [alertDialogOpen, setAlertDialogOpen] = useState(false);
  const [programs, setPrograms] = useState([]);
  const [industry, setIndustry] = useState([]);
  const [functions, setFunctions] = useState([]);
  const [allStoriesData, setAllStroiesData] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPage, setTotalPage] = useState(0);
  const [totalPost, setTotalPost] = useState(0);
  const [moreLess, setMoreLess] = useState(false);
  const [loading, setLoading] = useState(true);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [storyName, setStoryName] = useState({});
  const [queryParms, setQueryParms] = useState({});

  let navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    AOS.init({ once: true, duration: 1000, easing: "ease-in-out" });
  }, []);

  useEffect(() => {
    // SPA navigation leaves [data-aos] at opacity:0 until AOS re-scans the DOM
    const timer = setTimeout(() => {
      AOS.refreshHard();
    }, 150);
    return () => clearTimeout(timer);
  }, [location.pathname, allStoriesData, loading]);

  const handleCloseAlert = () => {
    setAlertDialogOpen(false);
    // setLoading(true);
  };

  const fetchData = async () => {
    try {
      const result = await fetchStoriesData(pageNumber);
      if (result.statusCode === 200) {
        const normalizeStories = (data) =>
          Array.isArray(data) ? data : Object.values(data || {}).flat();

        if (pageNumber === 1) {
          setMoreLess(false);
          setAllStroiesData(normalizeStories(result.data));
          setPageNumber(pageNumber + 1);
          setLoading(false);
        } else if (parseInt(totalPage) === pageNumber) {
          setButtonLoading(true);
          setMoreLess(true);
          setPageNumber(1);
          const combinedArray = normalizeStories(result.data);
          setAllStroiesData((prevValues) => [...prevValues, ...combinedArray]);
          setLoading(false);
        } else {
          setButtonLoading(true);
          setPageNumber(pageNumber + 1);
          const combinedArray = normalizeStories(result.data);
          setAllStroiesData((prevValues) => [...prevValues, ...combinedArray]);
          setLoading(false);
        }
        setLoading(false);
        setButtonLoading(false);
      } else {
        setAlertDialogOpen(true);
        setLoading(false);
      }
    } catch (error) {
      setPageNumber(1);
      setLoading(false);
    }
  };

  useEffect(() => {
    setPageNumber(pageNumber);
  }, [pageNumber]);

  const getCount = async () => {
    try {
      const counts = await getCounts();
      setTotalPage(counts.totalPage);
      setTotalPost(counts.totalPost);

      setPrograms(counts?.programObj);
      setIndustry(counts?.IndustryObj);
      setFunctions(counts?.functionObj);
      // setLoading(false);
    } catch (error) {
      // setLoading(false);
    }
  };

  const extractYouTubeVideoId = (url) => {
    const regex =
      /^https?:\/\/(?:www\.)?youtu(?:be\.com\/(?:watch\?(?:.*&)?v=|v\/|embed\/)|\.be\/)([\w\-_]+)(?:.*)$/i;
    const match = url?.match(regex);
    if (match) {
      return match[1];
    } else {
      return null;
    }
  };

  const handleProgramChange = (event, newValue) => {
    setLoading(true);
    if (newValue === null) {
      delete storyName["program"];
      setStoryName({ ...storyName });

      // fetchData();
      // getCount();
      delete queryParms["programId"];
      setQueryParms({ ...queryParms });
    } else if (newValue.programName === "LEP") {
      setAllStroiesData([]);
      fetchData();
      getCount();
      setStoryName({ ...storyName, program: newValue.programName });
    } else {
      setAllStroiesData([]);
      setQueryParms({ ...queryParms, programId: newValue.programId });
      setStoryName({ ...storyName, program: newValue.programName });
      setPageNumber(1);
      setMoreLess(true);
    }
  };

  const handleIndustryChange = (event, newValue) => {
    setLoading(true);
    if (newValue === null) {
      delete storyName["industry"];
      setStoryName({ ...storyName });
      delete queryParms["industryId"];
      setQueryParms({ ...queryParms });
    } else {
      setAllStroiesData([]);
      setQueryParms({ ...queryParms, industryId: newValue.industryId });
      setStoryName({ ...storyName, industry: newValue.industryName });
      setPageNumber(1);
      setMoreLess(true);
    }
  };

  const handleFunctionChange = (event, newValue) => {
    setLoading(true);
    if (newValue === null) {
      delete queryParms["functionId"];
      setQueryParms({ ...queryParms });
      delete storyName["function"];
      setStoryName({ ...storyName });
    } else {
      setAllStroiesData([]);
      setQueryParms({ ...queryParms, functionId: newValue.functionId });
      setStoryName({ ...storyName, function: newValue.functionName });
      setPageNumber(1);
      setMoreLess(true);
    }
  };

  useEffect(() => {
    if (JSON.stringify(queryParms) !== "{}") getCatgoriesData(queryParms);
    else {
      setLoading(true);
      fetchData();
      getCount();
    }
  }, [queryParms]); // eslint-disable-line react-hooks/exhaustive-deps

  const getCatgoriesData = async (queryParms) => {
    try {
      const response = await getCatgoryData(queryParms);
      setAllStroiesData(response?.successStoryDetails);
      setTotalPost(response?.storyCount);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  return (
    <>
      <section id="success-stories" className={bm.breakthrough} aria-label="Success stories">
        <div className={`${bm["breakthrough-header"]} ${Styles["stories-header-tight"]}`}>
          <span className={bm.eyebrow}>Success stories</span>
          <h2>In their words.</h2>
          <p className={bm.sub}>Explore journeys by program, industry, or function — then open a story to go deeper.</p>
        </div>

        <div className={Styles["stories-inner"]}>
        <div className={Styles["dropdown-container"]}>
          <div className={Styles["dropdown-programs"]}>
            <Autocomplete
              disablePortal
              id="combo-box-demo"
              options={programs}
              getOptionLabel={(option) => option?.programName || ""}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              className={Styles["auto-complete"]}
              onChange={handleProgramChange}
              renderInput={(params) => (
                <TextField {...params} label="Programs" sx={filterFieldSx} />
              )}
            />
          </div>
          <div className={Styles["dropdown-programs-author"]}>
            <Autocomplete
              disablePortal
              id="combo-box-industry"
              options={industry}
              getOptionLabel={(option) => option?.industryName || ""}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              className={Styles["auto-complete"]}
              onChange={handleIndustryChange}
              renderInput={(params) => (
                <TextField {...params} label="Industry" sx={filterFieldSx} />
              )}
            />
          </div>
          <div className={Styles["dropdown-programs-author"]}>
            <Autocomplete
              disablePortal
              id="combo-box-functions"
              options={functions}
              getOptionLabel={(option) => option?.functionName || ""}
              isOptionEqualToValue={(option, value) => option?.id === value?.id}
              className={Styles["auto-complete"]}
              onChange={handleFunctionChange}
              renderInput={(params) => (
                <TextField {...params} label="Functions" sx={filterFieldSx} />
              )}
            />
          </div>
        </div>

        {loading && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              marginTop: "3vw",
            }}
          >
            <ThreeCircles
              height="100"
              width="100"
              color="#F52929"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
              ariaLabel="three-circles-rotating"
              outerCircleColor=""
              innerCircleColor=""
              middleCircleColor=""
            />
          </div>
        )}

        {totalPost !== 0 && loading === false ? (
          <>
            <div className={Styles["stroy-count-container"]}>
              <span
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["all-stroy"]}
              >
                {JSON.stringify(storyName) !== "{}"
                  ? Object.values(storyName).join(", ")
                  : "All Stories"}
              </span>
            </div>

            <div className={Styles["card-container"]}>
              {(Array.isArray(allStoriesData)
                ? allStoriesData
                : Object.values(allStoriesData || {}).flat()
              ).map((val) => {
                const storyPath =
                  "/success-story/" +
                  val.fullNameOfStoryTeller.split(" ").join("_") +
                  "/" +
                  val.postId;
                const goToStory = () => navigate(storyPath);
                const onStoryKeyDown = (e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    goToStory();
                  }
                };

                return (
                <article
                  key={val.postId}
                  data-aos="fade-up"
                  data-aos-duration="1000"
                  data-aos-easing="ease-in-out"
                  className={Styles["card"]}
                >
                  <div
                    className={Styles["inner-card"]}
                    role="link"
                    tabIndex={0}
                    onClick={goToStory}
                    onKeyDown={onStoryKeyDown}
                    style={{ cursor: "pointer" }}
                  >
                    {val?.successStoryPostYouTubeLink ? (
                      <iframe
                        className={Styles["iframe"]}
                        title={val?.pageTitle ? `${val.pageTitle} — video` : "Success story video"}
                        src={
                          "https://www.youtube.com/embed/" +
                          extractYouTubeVideoId(
                            val?.successStoryPostYouTubeLink
                          )
                        }
                        id={`story-embed-${val.postId}`}
                        loading="lazy"
                        style={{ pointerEvents: "none" }}
                      />
                    ) : (
                      <img
                        alt={val?.pageTitle || val?.fullNameOfStoryTeller || "Success story"}
                        src={val?.successStoryPostImageLink}
                        className={Styles["user-image"]}
                      />
                    )}
                  </div>
                  <div className={Styles["card-bottom-section"]}>
                    <div className={Styles["card-text-block"]}>
                      <span
                        role="link"
                        tabIndex={0}
                        onClick={goToStory}
                        onKeyDown={onStoryKeyDown}
                        className={Styles["card-title"]}
                      >
                        {val?.pageTitle}
                      </span>
                      <span
                        role="link"
                        tabIndex={0}
                        onClick={goToStory}
                        onKeyDown={onStoryKeyDown}
                        className={Styles["card-name"]}
                      >
                        {val?.fullNameOfStoryTeller}
                      </span>
                      <span
                        role="link"
                        tabIndex={0}
                        onClick={goToStory}
                        onKeyDown={onStoryKeyDown}
                        className={Styles["designation"]}
                      >
                        {val?.fullNameOfStoryTellerDesignation}
                      </span>
                    </div>

                    <div
                      className={Styles["know-more-div"]}
                      role="link"
                      tabIndex={0}
                      onClick={goToStory}
                      onKeyDown={onStoryKeyDown}
                    >
                      <span className={Styles["know-more"]}>
                        View full story
                      </span>
                      <img
                        alt=""
                        src={urls.rightUpArrow}
                        className={Styles["right-arrow"]}
                      />
                    </div>
                  </div>
                </article>
                );
              })}
            </div>

            {buttonLoading && (
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  marginTop: "1vw",
                }}
              >
                <ThreeCircles
                  height="100"
                  width="100"
                  color="#F52929"
                  wrapperStyle={{}}
                  wrapperClass=""
                  visible={true}
                  ariaLabel="three-circles-rotating"
                  outerCircleColor=""
                  innerCircleColor=""
                  middleCircleColor=""
                />
              </div>
            )}

            {moreLess === false && (
              <div
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["button-container"]}
              >
                <ButtonWithLinks
                  name="Load More"
                  linkTo="action"
                  className="button-load-more-impact"
                  callback={fetchData}
                />
              </div>
            )}
          </>
        ) : (
          <>
            {totalPost === 0 && loading === false && (
              <div
                data-aos="fade-up"
                data-aos-duration="1000"
                data-aos-easing="ease-in-out"
                className={Styles["no-data"]}
              >
                <img
                  alt=""
                  src={urls.noData}
                  className={Styles["no-data-image"]}
                ></img>
              </div>
            )}
          </>
        )}
        </div>
      </section>

      {alertDialogOpen && (
        <div className={Styles["dialog-main-div"]}>
          <Dialog
            className={Styles["dialog-content-div"]}
            open={alertDialogOpen}
            onClose={handleCloseAlert}
          >
            <DialogTitle className={Styles["dialog-title-msg"]}>
              "Error while fetching success stories"
              <DialogActions className={Styles["dialog-action"]}>
                <ButtonWithLinks
                  name="Ok"
                  className={"button"}
                  linkTo="action"
                  callback={handleCloseAlert}
                />
              </DialogActions>
            </DialogTitle>
          </Dialog>
        </div>
      )}
    </>
  );
}
